import React, {useEffect, useRef, useState, useContext} from 'react';
import { AppContext } from "../../../context/AppContext";
import {useGlobal} from "reactn";
import { Image } from 'antd';
import {FiPhoneMissed} from "react-icons/fi";

const MessageZaloPersonalTemplate = ({messageItems}) => {
    const { i18n } = useContext(AppContext);
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const chatMode = useGlobal('chatMode')[0];
    const arrayKey = [1, 2, 3, 4, 5, 6];

    const onMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
    };

    const onMouseLeaveOrUp = () => {
        setIsDragging(false);
    };

    const onMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 1.5; // Tốc độ cuộn (nhân đôi tốc độ)
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    const getMediaTitle = (message) => {
        let mediaTitle = message.title;

        if(message?.params){
            const json = JSON.parse(message.params);
            mediaTitle = json?.mediaTitle;
        }

        return mediaTitle;
    }

    const getSourceHref = (message) => {
        let source = message.href;

        if(message?.params){
            const json = JSON.parse(message.params);
            source = json?.src;
        }

        return source;
    }

    const getCallTypeText = (message) => {
        let callType = 0;

        if(message?.params){
            const json = JSON.parse(message.params);
            callType = json?.calltype;
        }

        console.log({callType});

        if(callType === 0){
            return 'Cuộc gọi thoại'
        }
        else if(callType === 1){
            return 'Cuộc gọi video'
        }

        return '';
    }

    const renderMessageItem = (message, index) => {
        const key = arrayKey[index];
    
        if (message.action === 'recommened.link') {
            return (
                <div key={key} className="slide-item" style={{ maxWidth: '350px', marginLeft: 0 }}>
                    <a href={message.href} style={{ display: 'block', marginBottom: '5px' }}>{message.href}</a>
                    <div className="product-image text-center">
                        <Image
                        src={message.thumb || "error"}
                        alt={message.title}
                        fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6U..."
                        />
                    </div>
                    <div className="product-info mt-2">
                        <a href={message.href} className="product-name" style={{ height: 'auto' }}>{getMediaTitle(message)}</a>
                        {message.description && (
                        <div className="product-description limit-text">{message.description}</div>
                        )}
                        <a href={message.href} style={{ display: 'block' }}>{getSourceHref(message)}</a>
                    </div>
                </div>
            );
        }
    
        if (message.action === 'recommened.misscall') {
            return (
                <div key={key} style={{ padding: '10px', marginLeft: 0 }}>
                    <div className="product-info">
                        <div style={{ height: 'auto', fontWeight: 600, color: 'red' }}>Bạn bị nhỡ</div>
                        <div><FiPhoneMissed/> {getCallTypeText(message)}</div>
                    </div>
                </div>
            );
        }
    
        return <></>;
    };

    return (
        <div
            ref={scrollRef}
            onMouseDown={onMouseDown}
            onMouseLeave={onMouseLeaveOrUp}
            onMouseUp={onMouseLeaveOrUp}
            onMouseMove={onMouseMove}
            className="slider-wrapper"
            style={{ width: '100%' }}>
                {messageItems && messageItems.length > 0 && (
                    messageItems.map((message, index) => renderMessageItem(message, index))
                )}
        </div>
    );
}

export default MessageZaloPersonalTemplate;